import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { useTrackMarketplaceEvent } from 'marketplace-ui-tracking';
import { getMarketplaceInteractionEvent } from 'marketplace-ui-tracking/events/marketplace';
import { Link } from 'react-router-dom';
import { useScrollToTop } from '../hooks/useScrollToTop';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function AllProductsCard({
  seeMoreHref,
  seeMoreText,
  sectionIndex,
  sectionType,
  subscreen
}) {
  const scrollToTop = useScrollToTop();
  const trackMarketplaceEvent = useTrackMarketplaceEvent();

  // Determine the default subscreen and content based on section type
  const getCardConfig = () => {
    switch (sectionType) {
      case 'ALL_APPS':
        return {
          defaultSubscreen: 'all apps section',
          testId: 'all-apps-card',
          titleMessage: 'marketplaceStorefront.allAppsCard.title',
          descriptionMessage: 'marketplaceStorefront.allAppsCard.description'
        };
      case 'ALL_AGENTS':
        return {
          defaultSubscreen: 'all agents section',
          testId: 'all-agents-card',
          titleMessage: 'marketplaceStorefront.allAgentsCard.title',
          descriptionMessage: 'marketplaceStorefront.allAgentsCard.description'
        };
      default:
        // ALL_PRODUCTS
        return {
          defaultSubscreen: 'all products section',
          testId: 'all-products-card',
          titleMessage: 'marketplaceStorefront.allProductsCard.title',
          descriptionMessage: 'marketplaceStorefront.allProductsCard.description'
        };
    }
  };
  const {
    defaultSubscreen,
    testId,
    titleMessage,
    descriptionMessage
  } = getCardConfig();
  const finalSubscreen = subscreen || defaultSubscreen;
  const trackSeeMoreClick = () => trackMarketplaceEvent(getMarketplaceInteractionEvent({
    action: 'see more link clicked',
    itemIndex: sectionIndex,
    section: String(sectionType),
    subscreen: finalSubscreen
  }));
  return /*#__PURE__*/_jsx(View, {
    marginBlockEnd: "1000",
    "data-test-id": testId,
    children: /*#__PURE__*/_jsx(CardWrapper, {
      children: /*#__PURE__*/_jsx(CardSection, {
        children: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          flexDirection: "column",
          justifyContent: "center",
          padding: "800",
          children: [/*#__PURE__*/_jsx(Text, {
            as: "h3",
            typography: "heading-400",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: titleMessage
            })
          }), /*#__PURE__*/_jsx(Text, {
            color: "text-core-subtle",
            marginBlockStart: "200",
            marginBlockEnd: "600",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: descriptionMessage
            })
          }), /*#__PURE__*/_jsx(Link, {
            to: seeMoreHref,
            onClick: () => {
              scrollToTop();
              trackSeeMoreClick();
            },
            children: /*#__PURE__*/_jsx(Button, {
              use: "tertiary-extra-light",
              children: seeMoreText
            })
          })]
        })
      })
    })
  });
}